import { render, staticRenderFns } from "./WaybillEditRX.vue?vue&type=template&id=36400357&scoped=true&"
import script from "./WaybillEditRX.vue?vue&type=script&lang=js&"
export * from "./WaybillEditRX.vue?vue&type=script&lang=js&"
import style0 from "./WaybillEditRX.vue?vue&type=style&index=0&id=36400357&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36400357",
  null
  
)

export default component.exports